import { Vorversicherer } from '../data/vorversicherung';
import { StateV12 } from './12_vorversicherungData_changed.interface';

export const vorversicherungDataChanged = (
  previousState: StateV12,
  newVersion: number,
): StateV12 => {
  let filteredVersicherungData: Vorversicherer[] = previousState.versicherungData;
  if (filteredVersicherungData && filteredVersicherungData.length > 0) {
    filteredVersicherungData = filteredVersicherungData.filter(vd => vd.value !== 'DCI');
  }
  return {
    ...previousState,
    version: newVersion,
    versicherungData: filteredVersicherungData,
  };
};
